import { useI18n } from "../../i18n/I18nProvider";
import { Container } from "./styles";

export function TrustedBy() {
  const { t } = useI18n();
  const data = t.testimonials;
  if (!data?.companies?.length) return null;

  return (
    <Container aria-label={data.trustedBy}>
      <p className="trusted-heading">{data.trustedBy}</p>
      <div className="companies">
        {data.companies.map((c, i) => (
          <span key={i} className="company-name">{c}</span>
        ))}
      </div>
    </Container>
  );
}
